export const iconFontAwesomeAlphabetR = (
	<i className="fa-solid fa-r"></i>
);
